// Shared by the gamification admin panels (settings, quests).
export const MAX_CREDITS = 100_000;
export const MAX_BUDGET = 100_000_000;

export function parseWhole(v: string): number | null {
  if (!/^\d+$/.test(v.trim())) return null;
  return parseInt(v.trim(), 10);
}

export function parseOptionalWhole(v: string): number | null | undefined {
  if (!v.trim()) return null;
  return parseWhole(v) ?? undefined;
}

export function numStr(n: number | null | undefined): string {
  return n === null || n === undefined ? "" : String(n);
}

export function Toggle({ checked, onChange, disabled, label }: { checked: boolean; onChange: (v: boolean) => void; disabled?: boolean; label: string }) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={label}
      disabled={disabled}
      onClick={() => onChange(!checked)}
      className={`relative inline-flex h-6 w-11 shrink-0 items-center rounded-full transition-colors disabled:opacity-40 disabled:cursor-not-allowed ${checked ? "bg-emerald-600" : "bg-gray-700"}`}
    >
      <span className={`inline-block h-4 w-4 rounded-full bg-white transition-transform ${checked ? "translate-x-6" : "translate-x-1"}`} />
    </button>
  );
}
